// TODO: REFACTORING
import React from 'react';
import Style from './style.module.css';

const SpinningWheel = props => {
  return <div className={Style.spinningWheel} />;
};

export default SpinningWheel;
